import { useLoaderData } from "@tanstack/react-router";

export default function useUserInfos() {
	const data = useLoaderData({ from: "/app/_layout" });

	return data?.user;
}
